<template>
    <div>
        <span v-for="enumCaption in enumCaptions"
             v-if="enumCaption.value == value"
             :class="'state-display-container' + ' ' + (customClass || '') " :style="enumCaption.style"
        >{{enumCaption.caption}}
        </span>
    </div>
</template>

<script>
    export default {
        name: "EnumRender",
        props: {
            enumCaptions: Array,
            value: [Number, String],
            customClass: String
        }
    }
</script>

<style scoped>
    .state-display-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 14px;
    }
    /*.caption {*/

    /*}*/
    /*.value {*/
    /*    font-weight: bold;*/
    /*    margin-left: 5px;*/
    /*}*/
</style>



// WEBPACK FOOTER //
// src/components/render/EnumRender.vue